import * as React from "react";
import { IMemberOrchestrators } from "./types";

export const MemberOrchestratorContext =
  // eslint-disable-next-line unicorn/no-null
  React.createContext<IMemberOrchestrators | null>(null);

export function useMemberOrchestrator() {
  const value = React.useContext(MemberOrchestratorContext);

  if (value === null) {
    throw new Error("`Missing memberContext` in tree.");
  }

  return value;
}
